import { render, staticRenderFns } from "./RequireScript.vue?vue&type=template&id=4349ce4e"
import script from "./RequireScript.vue?vue&type=script&lang=js"
export * from "./RequireScript.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports